import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconPinLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.5 5v7.211l1.565 1.566a.745.745 0 0 1 .223.539v.427c0 .211-.072.39-.218.537a.731.731 0 0 1-.541.22H12.75v5.389c0 .212-.072.39-.216.534a.727.727 0 0 1-.534.215.725.725 0 0 1-.534-.215.726.726 0 0 1-.216-.534V15.5H7.471a.731.731 0 0 1-.541-.22.733.733 0 0 1-.218-.537v-.427a.768.768 0 0 1 .223-.539L8.5 12.211V5h-.25a.725.725 0 0 1-.534-.216.726.726 0 0 1-.216-.534c0-.213.072-.391.216-.534A.725.725 0 0 1 8.25 3.5h7.5c.213 0 .39.072.534.216a.726.726 0 0 1 .216.534.726.726 0 0 1-.216.535.726.726 0 0 1-.534.215h-.25Zm-6.65 9h6.3L14 12.85V5h-4v7.85L8.85 14Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconPinLine;
